import { EventEmitter } from "@angular/core";
import { Subject } from "rxjs";

class EventEmitterFunctions
{
    hasSubscribers<T = unknown>(eventEmitter: EventEmitter<T>): boolean
    {
        // TODO - The `observers: Observers<>` field will be replaced with an `observed:boolean` in rxjs@7
        return !!eventEmitter
            && (eventEmitter as Subject<unknown>).observers?.length > 0;
    }
}

export const EventEmitterHelper = new EventEmitterFunctions();
